import { createContext } from 'react';
export const PublicI18nContext = /*#__PURE__*/createContext({
  i18nLoader: null
});